import type { Reaction } from '@kinop/shared';
import { LIMITS } from '@kinop/shared';

interface ReactionLayerProps {
  reactions: Reaction[];
  /** Серверные часы: по ним у всех совпадает момент угасания. */
  serverNow: () => number;
}

/**
 * Реакции, всплывающие поверх кадра.
 *
 * Каждая появляется там, куда нажали, и уходит вверх. Анимация задаётся
 * отрицательной задержкой: реакция, отправленная две секунды назад,
 * подхватывается с середины — и у вошедшего позже она не начинается заново.
 */
export function ReactionLayer({ reactions, serverNow }: ReactionLayerProps): JSX.Element {
  const now = serverNow();

  return (
    <div className="reactions" aria-hidden="true">
      {reactions.map((reaction) => {
        const age = now - reaction.createdAt;
        if (age >= LIMITS.reactionLifetimeMs) return null;
        return (
          <span
            key={reaction.id}
            className="reactions__item"
            style={{
              left: `${reaction.point.x * 100}%`,
              top: `${reaction.point.y * 100}%`,
              animationDelay: `${-age}ms`,
            }}
          >
            {reaction.emoji}
          </span>
        );
      })}
    </div>
  );
}
